import { FieldValues } from 'react-hook-form';

import { storage } from '@/services/storage';

import { IFormStorage, WatchedValues } from './types';

class FormLocalStorage<TFieldValues extends FieldValues> implements IFormStorage<TFieldValues> {
  getItem(key: string) {
    const value = storage.getItem(key);

    return value ? JSON.parse(value) : null;
  }

  setItem(key: string, values: WatchedValues<TFieldValues>) {
    storage.setItem(key, JSON.stringify(values));
  }

  removeItem(key: string) {
    storage.removeItem(key);
  }
}

const formLocalStorage = new FormLocalStorage();

export { formLocalStorage };
